__turbopack_context__.v({
  "fadeInSlideUp": "oU5k8q_fadeInSlideUp",
  "visible": "oU5k8q_visible",
});
